module.exports = __webpack_public_path__ + "media/student_finance/financial-aid_rollover-caaec0c7.jpg";